export default "__VITE_ASSET__Hb30x9YN__"